import useTranslator from "../../hooks/useTranslator";
import DownloadIcon from "../../assets/img/downloadIcon.svg";
import DocIcon from "../../assets/img/DocIcon.svg";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import noticIcon from "../../assets/img/noticIcon.svg";
import Document from "../../assets/img/Document.svg";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import constants from "../../Utils/constants";
import TenantContext from "../../context/tenant/TenantContext";
import moment from "moment";
import {
  haveValue,
  removeUuidFromFileName,
  toast,
  getOnfidoCustomMessage,
} from "../../helper/common";
import { Spinner } from "react-bootstrap";
import DocHistoryPopup from "../Property/DocHistoryPopup";
import DotIcon from "../../assets/img/DotIcon.svg";
import DocUploadingComponentWithAnalysing from "../Tenant/DocUploadingComponentWithAnalysing";
import DeleteConfirationForDoc from "./DeleteConfirmationForDoc";
import {
  dea_missing_docs,
  docsMap,
  forensic_docs_map,
} from "../../Utils/skorLiteDocumentMap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import LoadingSpinner from "../LoadingSpinner";
import { Tooltip as ReactTooltip } from "react-tooltip";
import AuthContext from "../../context/auth/AuthContext";
import {
  FilterTag,
  OtherDocsSection,
  ProtectedHousingSection,
  IdentificationSection,
  EmploymentStatusSection,
  IncomeTaxesSection,
  ScannedTooltip,
  MissingDocTooltip,
  WarningTooltip,
  HighRiskTooltip,
  NoDocumentsFound,
} from "./DocumentSection";
import { DOCUMENT_CATEGORIES } from "../../Utils/document-categories";
import {
  PAYSLIP_ORDER,
  countFilledPayslipSlots,
  isThreePayslipEmploymentStatus,
} from "../../Utils/payslipRequirement";
import { isSkorSdkSearch } from "../../helper/skorSdk";

const DetailsDocs = (props) => {
  const {
    user = {},
    setVerifiedDocs,
    setClaveDocs,
    forensicRawData,
    forensicAnalysis,
    uploadDocModel,
    setUploadDocModel,
    isGuarantor = false,
    readOnly = false,
    isFromReport,
    currentLang,
    setGlobalTenantDocuments,
    setGlobalAllForensicDocuments,
    setGlobalMandatoryDocsList,
    setGlobalTenantDocsHistory,
    llShowOnly,
    isDeaRulesActivated,
    reportMode = false,
    missingDocumentsResolved = false,
    onDocsLoadingChange,
  } = props;

  const forensicDocsMap = isDeaRulesActivated
    ? dea_missing_docs
    : forensic_docs_map;

  const { _t } = useTranslator();
  const { fetchTenantDocs, getZipDocs, deleteDocument } =
    useContext(TenantContext);
  const { loadUserTenant, user: originalUser } = useContext(AuthContext);
  const [tenantDocsDataOriginal, setTenantDocsDataOriginal] = useState([]);
  const [tenantDocsData, setTenantDocsData] = useState([]);
  const [tenantDocsHistory, setTenantDocsHistory] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [mandatoryDocsList, setMandatoryDocsList] = useState({});
  const [docHistoryPopup, setDocHistoryPopup] = useState(false);
  const [selectedTypeForHistory, setSelectedTypeForHistory] = useState(null);
  const [docModel, setDocModel] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [allForensicDocuments, setAllForensicDocuments] = useState({});
  const [deleteDocumentConfirmation, setDeleteDocumentConfirmation] =
    useState(false);
  const [selectedDocument, setselectedDocument] = useState(null);
  const [deleteDocumentLoading, setDeleteDocumentLoading] = useState(false);
  const [documentsByType, setdocumentsByType] = useState({});
  const [employmentType, setEmploymentType] = useState("");
  const [forensicDocumentReport, setForensicDocumentReport] = useState({});
  const [showDropdown, setShowDropdown] = useState({
    first: false,
    sec: false,
    third: false,
    fourth: false,
    processing: false,
    protectedHousing: false,
  });
  const [allRenderedDocumentsCount, setAllRenderedDocumentsCount] = useState(0);
  const [selectedVerdicts, setSelectedVerdicts] = useState([]);

  const isProfileOutdated = !!(user?.profile_outdated || user?.is_outdated);
  // Tenant viewing a guarantor's profile is strictly view-only: no uploads,
  // no deletes. `isGuarantor` covers existing callers; `readOnly` is explicit.
  const isReadOnly = readOnly === true || isGuarantor === true;

  const toggleVerdictFilter = (verdict) => {
    setSelectedVerdicts((prev) =>
      prev.includes(verdict)
        ? prev.filter((v) => v !== verdict)
        : [...prev, verdict]
    );
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (reportMode) {
      if (haveValue(user?.tenantDocs)) {
        setTenantDocsDataOriginal(user.tenantDocs);
      } else {
        removeDocsData();
      }
      selectMandatoryDocsList();
      return;
    }
    fetchFileData();
    selectMandatoryDocsList();
  }, [user, reportMode]);

  const getKeyFactorByType = (keyFactorsArray, targetKey) => {
    return keyFactorsArray.find(
      (kf) => kf?.keyFactor?.toLowerCase() === targetKey.toLowerCase()
    );
  };

  const getDocumentAnalysisPayload = () =>
    user?.tenant_extra_id?.document_analysis ??
    user?.tenant_extra_field_id?.document_analysis ??
    {};

  const getFileNameFromUrl = (url) => {
    if (!haveValue(url) || typeof url !== "string") return "";

    try {
      const pathname = new URL(url).pathname;
      return pathname?.split("/").filter(Boolean).pop() ?? "";
    } catch (error) {
      return url?.split("?")[0]?.split("/").filter(Boolean).pop() ?? "";
    }
  };

  const getMappedDbType = (analysisDoc = {}, bucket = {}) => {
    const analysisTypeMap = {
      "National Identity Card (Front)": "national_identity_card_front",
      "National Identity Card (Back)": "national_identity_card_back",
      "Residence Permit (Front)": "residence_permit_front",
      "Residence Permit (Back)": "residence_permit_back",
      Passport: "passport",
    };

    return (
      analysisTypeMap?.[analysisDoc?.documentName] ??
      analysisTypeMap?.[bucket?.bucketName] ??
      docsMap?.[analysisDoc?.documentName] ??
      docsMap?.[bucket?.bucketName] ??
      analysisDoc?.documentName ??
      bucket?.bucketName ??
      ""
    );
  };

  const normalizeComparableValue = (value) =>
    (value ?? "").toString().trim().toLowerCase().replace(/\s+/g, " ");

  const primaryProfileName =
    forensicAnalysis?.Name?.dataInJSON?.name ??
    `${user?.fname ?? ""} ${user?.lname ?? ""}`.trim();

  const getDocOwnerLabel = (doc) => {
    return doc?.analysisOwnerName || doc?.uploadedFor || "";
  };

  const isOtherUserDoc = (doc) => {
    if (!doc) return false;
    const ownerLabel = getDocOwnerLabel(doc);
    const normalizedOwnerLabel = normalizeComparableValue(ownerLabel);

    // "Other" is a placeholder owner value, not a separate document owner.
    if (normalizedOwnerLabel === constants.OTHER) return false;

    // A legal entity is always a third party, even when its profile is marked
    // as the uploader. Only fall back to the uploader/name checks otherwise.
    if (doc?.analysisOwnerType === "legal_entity") return true;
    if (doc?.analysisIsUploader === true) return false;
    if (doc?.analysisIsUploader === false) return true;

    if (!haveValue(ownerLabel)) return false;

    return (
      normalizedOwnerLabel !== normalizeComparableValue(primaryProfileName)
    );
  };

  const getDisplayDocName = (doc) => {
    if (!doc) return "";
    const langKey = currentLang === "en-us" ? "en" : "es";

    const bucketNameTranslated =
      doc?.documentAnalysisData?.documentNameTranslated?.[langKey];

    if (haveValue(bucketNameTranslated)) return bucketNameTranslated;

    if (haveValue(doc?.bucketName)) return doc.bucketName;

    return (
      allForensicDocuments?.[doc?.file_name]?.documentNameTranslated?.[
        currentLang === "en-us" ? "en" : "es"
      ] ??
      doc?.documentAnalysisData?.documentNameTranslated?.[
        currentLang === "en-us" ? "en" : "es"
      ] ??
      _t(doc?.type, "", "fixed")
    );
  };

  const getDocsForType = (targetType, categoryKeys = []) => {
    const keys = Array.isArray(categoryKeys) ? categoryKeys : [];

    return (tenantDocsData ?? [])
      .filter((doc) => {
        if (doc?.type === "uploaded-from-onboarding") return false;

        const matchesType = doc?.type === targetType;
        const matchesCategory =
          !!doc?.categoryKey && keys.includes(doc?.categoryKey);

        // Keep old behavior and include category-key matches as an additional rule.
        return matchesType || matchesCategory;
      })
      .filter((doc, index, docs) => {
        const uniqueKey =
          doc?.id ??
          doc?._id ??
          doc?.document_id ??
          doc?.file_name ??
          `${doc?.type}-${doc?.categoryKey}-${doc?.created_at}-${index}`;

        return (
          docs.findIndex((d, i) => {
            const dKey =
              d?.id ??
              d?._id ??
              d?.document_id ??
              d?.file_name ??
              `${d?.type}-${d?.categoryKey}-${d?.created_at}-${i}`;

            return dKey === uniqueKey;
          }) === index
        );
      })
      .sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at));
  };

  const getPayslipDocs = () =>
    (tenantDocsData ?? [])
      .filter((doc) => doc?.type?.toLowerCase()?.includes("payslip"))
      .sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at));

  const matchesSelectedVerdicts = (doc) => {
    if (!doc) return false;
    if (selectedVerdicts.length === 0) return true;

    let verdict =
      doc?.type === "Declaration Consent"
        ? "NORMAL"
        : forensicDocumentReport?.[doc?.file_name]?.verdict;

    const isScanned =
      doc?.type === "Declaration Consent"
        ? false
        : forensicDocumentReport?.[doc?.file_name]?.documentType ===
            "is_scanned_document" ||
          forensicDocumentReport?.[doc?.file_name]?.isScannedDocument === "yes";

    if (isScanned) {
      verdict = "SCANNED";
    }

    return (
      (!verdict && selectedVerdicts.includes("WARNING")) ||
      selectedVerdicts.includes(verdict)
    );
  };

  const getDocKey = (doc) => {
    if (!doc) return null;
    return (
      doc?.file_name ??
      doc?._id ??
      doc?.id ??
      doc?.document_id ??
      `${doc?.type ?? ""}-${doc?.categoryKey ?? ""}-${doc?.created_at ?? ""}`
    );
  };

  const getUsedDocsInSections = () => {
    const usedKeys = new Set();
    const addDocs = (docs) => {
      (Array.isArray(docs) ? docs : []).forEach((doc) => {
        const key = getDocKey(doc);
        if (key) usedKeys.add(key);
      });
    };

    const idDocs = forensicDocsMap?.[employmentType]?.identification ?? [];
    idDocs.forEach((item) => {
      addDocs(getDocsForType(item, [DOCUMENT_CATEGORIES.IDENTIFICATION]));
    });

    const empStatus =
      forensicDocsMap?.[employmentType]?.employment_status ?? {};
    const empDocs = [
      ...(empStatus?.compulsory ?? []),
      ...(empStatus?.additional ?? []),
    ];
    empDocs.forEach((item) => {
      addDocs(getDocsForType(item, [DOCUMENT_CATEGORIES.EMPLOYMENT_STATUS]));
    });

    const incomeStatus = forensicDocsMap?.[employmentType]?.income_taxes ?? {};
    const incomeDocs = [
      ...(incomeStatus?.compulsory ?? []),
      ...(incomeStatus?.additional ?? []),
    ];
    incomeDocs.forEach((item) => {
      if (item?.toLowerCase()?.includes("payslip")) {
        addDocs(getPayslipDocs());
      } else {
        addDocs(
          getDocsForType(item, [
            DOCUMENT_CATEGORIES.TAX,
            DOCUMENT_CATEGORIES.INCOME,
            DOCUMENT_CATEGORIES.PAYMENT_RECEIPT,
            DOCUMENT_CATEGORIES.FINANCIAL,
          ])
        );
      }
    });

    const housingDocs = getRequiredProtectedHousingDocs();
    housingDocs.forEach((item) => {
      addDocs(getDocsForType(item));
    });

    return usedKeys;
  };

  const getOtherDocs = () => {
    const usedDocKeys = getUsedDocsInSections();

    let otherDocs = (tenantDocsData ?? []).filter(
      (doc) =>
        doc?.type !== "uploaded-from-onboarding" &&
        !usedDocKeys.has(getDocKey(doc)) &&
        !doc?.file_name?.includes("grupomutuoconsent_") &&
        !doc?.file_name?.includes("skorconsent_")
    );

    if (selectedVerdicts.length > 0) {
      otherDocs = otherDocs.filter((doc) => matchesSelectedVerdicts(doc));
    }

    return otherDocs;
  };

  useEffect(() => {
    const tempMap = new Map(); // Tracks 'clave' types
    const typeMap = new Map(); // Latest doc per type (strictly by type)
    const otherDocs = []; // Docs with 'others' source
    const publicHousingMap = new Map(); // Latest doc per type for public housing
    const docHistoryMap = new Map(); // All docs grouped by type for history
    const verifiedDocsMap = new Map();
    if (
      Array.isArray(tenantDocsDataOriginal) &&
      tenantDocsDataOriginal.length > 0
    ) {
      const docsByFileName = new Map();
      const docsByType = new Map();

      tenantDocsDataOriginal.forEach((doc) => {
        if (haveValue(doc?.file_name)) {
          docsByFileName.set(doc.file_name, doc);
          docsByFileName.set(doc.file_name.split("/").pop(), doc);
        }

        if (!docsByType.has(doc?.type)) {
          docsByType.set(doc?.type, []);
        }
        docsByType.get(doc?.type).push(doc);

        // Track 'clave' types
        if (doc?.from === "clave") {
          tempMap.set(doc.file_name, doc);
        }
        // Keep latest doc per unique type for main display, excluding 'others'
        if (doc?.from !== constants.others) {
          const existingDoc = typeMap.get(doc.type);

          if (
            !existingDoc ||
            new Date(doc.created_at) > new Date(existingDoc.created_at)
          ) {
            typeMap.set(doc.type, doc);
          }
        }
        // Collect 'others' docs
        if (doc?.from === "others") {
          if (!doc?.type?.toLowerCase().includes("payslip")) {
            otherDocs.push(doc);
          }
        }
        // Keep latest doc per type for public housing docs
        if (doc?.from === "public_housing_docs") {
          const existing = publicHousingMap.get(doc.type);
          if (
            !existing ||
            new Date(doc.created_at) > new Date(existing.created_at)
          ) {
            publicHousingMap.set(doc.type, doc);
          }
        }
        // Build document history map by type
        if (!docHistoryMap.has(doc.type)) {
          docHistoryMap.set(doc.type, []);
        }
        docHistoryMap.get(doc.type).push(doc);
        //Get map of all Verified Docs
        if (!verifiedDocsMap.has(doc.type) && doc?.verified) {
          verifiedDocsMap.set(doc.file_name, doc);
        }
      });

      docsByType.forEach((docsArray) => {
        docsArray.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
      });

      // Sort history arrays descending (latest first)
      docHistoryMap.forEach((docsArray) => {
        docsArray.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
      });
      // Prepare final list for main display
      const publicHousingDocsSorted = Array.from(
        publicHousingMap.values()
      ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      const publicHousingTypes = new Set(
        publicHousingDocsSorted.map((doc) => doc.type)
      );
      const filteredTypeMapDocs = Array.from(typeMap.values()).filter(
        (doc) =>
          !publicHousingTypes.has(doc.type) &&
          !doc?.type?.toLowerCase().includes("payslip")
      );
      const allPayslips = tenantDocsDataOriginal.filter((d) =>
        d?.type?.toLowerCase().includes("payslip")
      );
      const finalDocs = [
        ...filteredTypeMapDocs,
        ...publicHousingDocsSorted,
        ...allPayslips,
        ...otherDocs,
      ];
      // add uploaded for field in each doc
      const docListWithKeyFactor = {};
      (Array.isArray(forensicRawData) ? forensicRawData : []).forEach(
        (entry) => {
          const name = getKeyFactorByType(
            entry?.report?.keyFactors?.keyFactors,
            "Name"
          )?.dataInJSON?.name;
          if (name) {
            docListWithKeyFactor[name] = entry?.report?.documents_list || [];
          }
        }
      );

      finalDocs.forEach((doc) => {
        for (const [name, docs] of Object.entries(docListWithKeyFactor)) {
          const matched = docs.find((d) => {
            const extracted = d?.url?.split(
              `/${process.env.REACT_APP_CDN_CONTAINER}/`
            )[1];
            return extracted === doc.file_name;
          });
          if (matched) {
            doc.uploadedFor = name;
            break;
          }
        }
      });

      const allForensicDocuments = (
        Array.isArray(forensicRawData) ? forensicRawData : []
      ).flatMap((entry) => {
        return (entry?.report?.documents_list || []).map((doc) => ({
          ...doc,
        }));
      });

      let forensicDocsObj = {};
      allForensicDocuments.forEach((doc) => {
        const extractedFileName = doc?.url?.split(
          `/${process.env.REACT_APP_CDN_CONTAINER}/`
        )[1];

        const extractedFileNameClean = extractedFileName?.split(`?`)?.[0];

        if (extractedFileNameClean) {
          forensicDocsObj[extractedFileNameClean] = doc;
        }
      });

      setAllForensicDocuments(forensicDocsObj);
      setGlobalAllForensicDocuments?.(forensicDocsObj);

      const documentAnalysis =
        getDocumentAnalysisPayload()?.profileReports ?? [];
      const uploaderProfile = documentAnalysis.find(
        (profile) => profile?.data?.is_uploader
      );
      const orderedProfiles = uploaderProfile
        ? [
            uploaderProfile,
            ...documentAnalysis.filter(
              (profile) => profile !== uploaderProfile
            ),
          ]
        : documentAnalysis;

      const analysisMatchedFileNames = new Set();
      const analysisBucketRows = [];

      orderedProfiles.forEach((profile) => {
        const ownerName = profile?.data?.owner || profile?.owner;
        const ownerType = profile?.data?.owner_type || profile?.owner_type;
        const documentBuckets = profile?.report?.documentBuckets ?? [];

        documentBuckets.forEach((bucket) => {
          const bucketDocuments = Array.isArray(bucket?.documents)
            ? bucket.documents
            : [];

          if (!bucketDocuments.length) return;

          const bucketDbMatches = bucketDocuments
            .map((analysisDoc) => {
              const bucketUrl =
                analysisDoc?.url ??
                analysisDoc?.data?.url ??
                analysisDoc?.data?.filename;
              const extractedFileName = getFileNameFromUrl(bucketUrl);
              const mappedType = getMappedDbType(analysisDoc, bucket);

              const matchedDoc =
                docsByFileName.get(extractedFileName) ??
                docsByType
                  .get(mappedType)
                  ?.find(
                    (doc) => !analysisMatchedFileNames.has(doc?.file_name)
                  ) ??
                docsByType.get(mappedType)?.[0];

              if (matchedDoc?.file_name) {
                analysisMatchedFileNames.add(matchedDoc.file_name);
              }

              return {
                analysisDoc,
                matchedDoc,
                mappedType,
              };
            })
            .filter(
              (entry) =>
                haveValue(entry?.mappedType) &&
                (haveValue(entry?.matchedDoc) || haveValue(entry?.analysisDoc))
            );

          bucketDbMatches.forEach((entry) => {
            if (entry?.matchedDoc?.file_name) {
              analysisMatchedFileNames.add(entry.matchedDoc.file_name);
            }
          });

          const selectedBucketDoc =
            bucketDbMatches.find(
              (entry) =>
                entry?.analysisDoc?.isDuplicate !== true &&
                haveValue(entry?.matchedDoc)
            ) ??
            bucketDbMatches.find(
              (entry) => entry?.analysisDoc?.isDuplicate !== true
            ) ??
            bucketDbMatches[0];

          if (!selectedBucketDoc) return;

          let { analysisDoc, matchedDoc, mappedType } = selectedBucketDoc;
          const fallbackFileName = getFileNameFromUrl(
            analysisDoc?.url ?? analysisDoc?.data?.url
          );

          if (
            user?.employment_status === constants.company &&
            mappedType === constants.quarterly_vat
          ) {
            const periodQuarter =
              analysisDoc?.documentAnalysisData?.period_quarter ??
              analysisDoc?.data?.period_quarter ??
              analysisDoc?.period_quarter;

            if (periodQuarter) {
              mappedType = `${mappedType} Q${periodQuarter}`;
            }
          }

          if (
            user?.employment_status === constants.company &&
            mappedType === constants.quarterly_vat
          ) {
            const periodQuarter =
              analysisDoc?.documentAnalysisData?.period_quarter ??
              analysisDoc?.data?.period_quarter ??
              analysisDoc?.period_quarter;

            if (periodQuarter) {
              mappedType = `${mappedType} Q${periodQuarter}`;
            }
          }

          if (matchedDoc) {
            analysisBucketRows.push({
              ...(matchedDoc ?? {}),
              type: mappedType,
              file_name: matchedDoc?.file_name ?? fallbackFileName,
              created_at: matchedDoc?.created_at ?? matchedDoc?.updated_at,
              uploadedFor:
                matchedDoc?.uploadedFor ??
                (profile?.data?.is_uploader ? "" : ownerName),
              analysisOwnerName: ownerName,
              analysisOwnerType: ownerType,
              analysisIsUploader: profile?.data?.is_uploader === true,
              bucketName: bucket?.bucketName ?? analysisDoc?.bucketName,
              categoryKey: analysisDoc?.categoryKey,
              bucketKey: bucket?.bucketKey,
              bucketDocuments: bucketDbMatches
                .map((entry) => entry?.matchedDoc)
                .filter(Boolean),
              documentAnalysisData: analysisDoc,
              isDocumentAnalysisBucket: true,
            });
          } else {
            console.log(
              "ERROR: Document is missing in the db docs, but it is present in the analysis bucket"
            );
          }
        });
      });

      const finalDocsToUse =
        analysisBucketRows.length > 0
          ? [
              ...analysisBucketRows,
              ...finalDocs.filter(
                (doc) =>
                  !analysisMatchedFileNames.has(doc?.file_name) &&
                  doc?.type !== "uploaded-from-onboarding"
              ),
            ]
          : finalDocs;

      finalDocsToUse.sort((a, b) => {
        const getPriority = (doc) => {
          if (doc?.from === "clave") return 0;
          if (doc?.verified === true) return 1;
          return 2;
        };

        return getPriority(a) - getPriority(b);
      });

      // Documents sorted by created and map by type
      const sortedAndMappedByType = finalDocsToUse
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .reduce((acc, doc) => {
          if (!acc[doc.type]) acc[doc.type] = doc; // only take the latest
          return acc;
        }, {});

      setdocumentsByType(sortedAndMappedByType);
      setTenantDocsData(finalDocsToUse);
      setGlobalTenantDocuments?.(finalDocsToUse);
      setTenantDocsHistory(Object.fromEntries(docHistoryMap));
      setGlobalTenantDocsHistory?.(Object.fromEntries(docHistoryMap));
      setVerifiedDocs(verifiedDocsMap);
      setClaveDocs(tempMap);
    }
  }, [tenantDocsDataOriginal, forensicRawData]);

  useEffect(() => {
    const forensicReportsMap = (
      Array.isArray(forensicRawData) ? forensicRawData : []
    )
      .flatMap((entry) => entry?.report?.forensic_reports || [])
      .reduce((acc, report) => {
        const fileName = report?.fileUrl?.split("/")?.pop();
        if (fileName) acc[fileName] = report;
        return acc;
      }, {});

    setForensicDocumentReport(forensicReportsMap);
  }, [forensicRawData]);

  const removeDocsData = () => {
    setTenantDocsData([]);
    setGlobalTenantDocuments?.([]);
    setTenantDocsHistory({});
    setGlobalTenantDocsHistory?.({});
    setTenantDocsDataOriginal([]);
  };

  const fetchFileData = async () => {
    if (haveValue(user)) {
      let userid = user?._id;
      onDocsLoadingChange?.(true);
      try {
        const res = await fetchTenantDocs(userid, false, isGuarantor);
        if (haveValue(res?.data?.success_res?.tenantDocs)) {
          setTenantDocsDataOriginal(res?.data?.success_res?.tenantDocs);
        } else {
          removeDocsData();
        }
      } finally {
        onDocsLoadingChange?.(false);
      }
    }
  };

  const getRequiredProtectedHousingDocs = () => {
    if (
      llShowOnly &&
      originalUser?.current_workspace?.protected_housing_enabled === false
    ) {
      return [];
    }

    const selectedProtectedDocs =
      user?.tenant_extra_field_id?.[constants.public_housing_fileFrom] ?? [];

    const residencyDoc = constants.certificate_of_residency_registration;
    const hasNoSpecialCircumstances = selectedProtectedDocs.includes(
      constants.no_special_circumstances
    );
    const baseProtectedDocs = selectedProtectedDocs.filter(
      (doc) =>
        doc &&
        doc !== residencyDoc &&
        doc !== constants.no_special_circumstances &&
        doc !== "no"
    );

    if (baseProtectedDocs.length > 0) {
      return Array.from(new Set([...baseProtectedDocs, residencyDoc]));
    }

    if (hasNoSpecialCircumstances) {
      return [residencyDoc];
    }

    return [];
  };

  const selectMandatoryDocsList = () => {
    let employment_docs = {};
    let selectedEmploymentType = "employed";
    if (user?.employment_status == "student") {
      selectedEmploymentType = "student";
      employment_docs = constants.PROFESSION_DOCS.STUDENT_DOCS;
    } else if (user?.employment_status == "employed") {
      selectedEmploymentType =
        user?.employment_category === constants.domestic_worker
          ? constants.domestic_worker
          : constants.employed;
      employment_docs =
        user?.employment_category === constants.domestic_worker
          ? constants.PROFESSION_DOCS.DOMESTIC_WORKER_DOCS
          : constants.PROFESSION_DOCS.EMPLOYED_DOCS;
    } else if (
      user?.employment_status == "self_employed" &&
      user?.employment_category === "freelancer"
    ) {
      selectedEmploymentType = "freelancer";
      employment_docs = constants.PROFESSION_DOCS.FREELANCER_DOCS;
    } else if (
      user?.employment_status == "self_employed" &&
      user?.employment_category === "ownACompany"
    ) {
      selectedEmploymentType = "ownACompany";
      employment_docs = constants.PROFESSION_DOCS.SELF_EMPLOYED_DOCS;
    } else if (user?.employment_status == "retired") {
      selectedEmploymentType = "retired";
      employment_docs = constants.PROFESSION_DOCS.RETIRED_DOCS;
    } else if (user?.employment_status == "unemployed") {
      selectedEmploymentType = "unemployed";
      employment_docs = constants.PROFESSION_DOCS.UNEMPLOYED_DOCS;
    } else if (user?.employment_status == "public_servant") {
      selectedEmploymentType = "public_servant";
      employment_docs = constants.PROFESSION_DOCS.PUBLIC_SERVANT_DOCS;
    } else if (user?.employment_status == "company") {
      selectedEmploymentType = "company";
      employment_docs = constants.PROFESSION_DOCS.COMPANY_DOCS;
    }
    const requiredProtectedHousingDocs = getRequiredProtectedHousingDocs();
    if (requiredProtectedHousingDocs.length > 0) {
      requiredProtectedHousingDocs.forEach((docType) => {
        employment_docs[docType] = docType;
      });
    }
    setEmploymentType(selectedEmploymentType);
    setMandatoryDocsList(employment_docs);
    setGlobalMandatoryDocsList?.(employment_docs);
  };

  const [showSpinner, setShowSpinner] = useState();

  const handleZipDown = () => {
    setShowSpinner(true);
    getZipDocs(user?._id, isGuarantor)
      .then((res) => {
        const nodeJSBuffer = res.data.images.data;
        const uint8Array = new Uint8Array(nodeJSBuffer);

        // Convert Uint8Array to ArrayBuffer
        const arrayBuffer = uint8Array.buffer;

        // Create a Blob
        const blob = new Blob([arrayBuffer], {
          type: "application/octet-stream",
        });

        // Create a download link
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `${user?.fname + " " + (user?.lname ?? "")}.zip`;

        document.body.appendChild(a);
        a.click();

        // Clean up
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
        setShowSpinner(false);
      })
      .catch((err) => {
        setShowSpinner(false);
        console.log(err);
      });
  };

  const handlePreviewDocument = (url) => {
    window.open(url, "blank");
  };

  const hasModel100Fallback = (key) =>
    key.toLowerCase().includes("model 100") &&
    tenantDocsData.some((doc) => doc?.categoryKey === DOCUMENT_CATEGORIES.TAX);

  const getPayslipUploadedCount = (history) =>
    Object.entries(history || {})
      .filter(([historyKey]) => historyKey.toLowerCase().includes("payslip"))
      .reduce(
        (sum, [, docs]) => sum + (Array.isArray(docs) ? docs.length : 0),
        0
      );

  // Slot-aware payslip requirement for employed / public_servant: the 3
  // payslips must cover the last-3-months periods (same as Income & Taxes
  // slots). Stale docs outside the window do NOT satisfy a slot.
  const isThreePayslipRequiredHere =
    employmentType === "employed" ||
    employmentType === "public_servant" ||
    isThreePayslipEmploymentStatus(user?.employment_status);
  const payslipSlotInfo = useMemo(
    () =>
      countFilledPayslipSlots(tenantDocsData, {
        user,
        forensicRawData,
        forensicByFile: allForensicDocuments,
      }),
    [tenantDocsData, user, forensicRawData, allForensicDocuments]
  );

  const missingDocs = (() => {
    const entries = Object.entries(mandatoryDocsList);
    const hasPayslipRequirement = entries.some(([key]) =>
      key.toLowerCase().includes("payslip")
    );
    const useSlots = hasPayslipRequirement && isThreePayslipRequiredHere;
    // Expand generic "Payslip" into the 3 ordered slots so each missing
    // period is reported (consistent with skorList + display slots).
    const expandedEntries = [];
    entries.forEach(([key, val]) => {
      const lower = key.toLowerCase();
      if (useSlots && (lower === "payslip" || lower === "last 3 payslips")) {
        PAYSLIP_ORDER.forEach((k) => expandedEntries.push([k, k]));
      } else {
        expandedEntries.push([key, val]);
      }
    });
    // Slot-filled count when slots apply, else document count (all payslips
    // share the single DB type "Payslip", so count docs, not history keys).
    const payslipSatisfiedCount = useSlots
      ? payslipSlotInfo.filled
      : getPayslipUploadedCount(tenantDocsHistory);
    return expandedEntries.filter(([key]) => {
      const isPayslipKey = key.toLowerCase().includes("payslip");

      if (hasModel100Fallback(key)) return false;

      if (isPayslipKey) {
        const index = PAYSLIP_ORDER.indexOf(key);

        if (index !== -1) {
          if (index < payslipSatisfiedCount) {
            return false;
          }
        } else {
          // Generic mandatory key for non-slot types: satisfied when enough
          // payslip documents exist (1, or 3 for "last 3").
          const needed = key.toLowerCase() === "last 3 payslips" ? 3 : 1;
          if (payslipSatisfiedCount >= needed) {
            return false;
          }
        }
      }

      return !(key in tenantDocsHistory && !isPayslipKey);
    });
  })();

  // const missingDocs = Object.entries(mandatoryDocsList).filter(
  //   ([key]) => !(key in tenantDocsHistory)
  // );

  const merged = [
    ...tenantDocsData,
    ...(missingDocs || []).map((doc) => ({
      ...doc,
      type: "missing",
    })),
  ];

  const reportMidpoint = Array.isArray(merged)
    ? Math.ceil(merged.length / 2)
    : 0;
  const reportDocsFirstHalf = Array.isArray(merged)
    ? merged.slice(0, reportMidpoint)
    : [];
  const reportDocsSecondHalf = Array.isArray(merged)
    ? merged.slice(reportMidpoint)
    : [];

  const docsToRender = isFromReport ? reportDocsFirstHalf : tenantDocsData;

  const handleDeleteDocument = async (doc_id) => {
    try {
      setDeleteDocumentLoading(true);
      await deleteDocument(doc_id, user?._id);
      if (originalUser?.role == "tenant") {
        await loadUserTenant("tenant");
      }
      await fetchFileData("tenant");
      setDeleteDocumentConfirmation(false);
    } catch (err) {
      toast.error(_t("failedToDeleteDocument"));
    } finally {
      setDeleteDocumentLoading(false);
    }
  };

  const scrollContainerRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const isTogglingDropdown = useRef(false);

  const handleViewDocument = (e, doc) => {
    e.preventDefault();
    e.stopPropagation();
    if (scrollContainerRef.current) {
      setScrollPosition(scrollContainerRef.current.scrollTop);
    }

    setSelectedTypeForHistory(doc.type);
    const itemIndexFromAllDocs = tenantDocsData?.findIndex(
      (data) => data?.file_name === doc.file_name
    );
    setSelectedIndex(itemIndexFromAllDocs);
    setDocHistoryPopup(true);
  };

  const getPreviousUploadsForPopup = () => {
    const selectedDoc = tenantDocsData?.[selectedIndex];

    if (selectedDoc?.isDocumentAnalysisBucket) {
      const bucketDocs = Array.isArray(selectedDoc?.bucketDocuments)
        ? selectedDoc.bucketDocuments
        : [];

      const normalizedBucketDocs = bucketDocs.length
        ? bucketDocs
        : selectedDoc?.file_name
          ? [selectedDoc]
          : [];

      return [...normalizedBucketDocs];
      // #NOTE: removed this sorting to show the correct doc in the History
      // .sort(
      //   (a, b) => new Date(b?.created_at) - new Date(a?.created_at),
      // );
    }

    return tenantDocsHistory?.[selectedTypeForHistory] ?? [];
  };

  useEffect(() => {
    if (!docHistoryPopup && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = scrollPosition;
    }
  }, [docHistoryPopup, scrollPosition]);

  const handleDropdownToggle = (section) => {
    // Save scroll position before toggling
    const scrollElement =
      scrollContainerRef.current?.closest(".your-scrollable-parent") ||
      scrollContainerRef.current;

    if (scrollElement) {
      setScrollPosition(scrollElement.scrollTop);
      isTogglingDropdown.current = true;
    }

    // Toggle the dropdown
    setShowDropdown((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const verdictPriority = {
    HIGH_RISK: 0,
    WARNING: 1,
    SCANNED: 2,
    NORMAL: 3,
    TRUSTED: 4,
  };

  useEffect(() => {
    if (isTogglingDropdown.current) {
      requestAnimationFrame(() => {
        const scrollElement =
          scrollContainerRef.current?.closest(".your-scrollable-parent") ||
          scrollContainerRef.current;

        if (scrollElement && scrollPosition > 0) {
          scrollElement.scrollTop = scrollPosition;
        }

        isTogglingDropdown.current = false;
      });
    }
  }, [showDropdown, scrollPosition]);

  const scannedDocsCount =
    (tenantDocsData ?? []).filter((doc) => {
      if (
        !doc?.isDocumentAnalysisBucket &&
        documentsByType?.[doc?.type]?.file_name !== doc?.file_name
      ) {
        return false;
      }

      const report = forensicDocumentReport?.[doc?.file_name];
      return (
        report?.documentType === "is_scanned_document" ||
        report?.isScannedDocument === "yes"
      );
    }).length || 0;

  const showOnfidoCustomTooltipMessages = (document) => {
    const customMessageData = getOnfidoCustomMessage(user, _t);
    if (
      document?.type
        ?.toLowerCase()
        .includes(customMessageData?.documentType?.toLowerCase()) &&
      document?.from === "others"
    ) {
      return customMessageData;
    }
    return null;
  };

  let processingDocs = tenantDocsDataOriginal?.length
    ? (tenantDocsDataOriginal?.filter(
        (d) => d?.type === "uploaded-from-onboarding"
      ) ?? [])
    : [];

  const DocumentLoading = () => {
    return (
      <div className="da-page">
        <div className="da-skeleton-rows">
          <div className="da-skeleton da-skeleton--w1" />
          <div className="da-skeleton da-skeleton--w2" />
          <div className="da-skeleton da-skeleton--w3" />
        </div>
        <div className="da-center-block">
          <div className="da-doc-icon">
            <div className="da-doc-line" />
            <div className="da-doc-line da-doc-line--short" />
            <div className="da-doc-circle" />
          </div>
          <p className="da-title">{_t("analysingYourDocuments")}</p>
          <p className="da-subtitle">
            {_t(
              "WeAreProcessingTheNewlyUploadedDocumentationYourProfileWillBeUpdatedAutomaticallyOnceComplete"
            )}
          </p>
          <p className="da-subtitle">
            {_t("weAreProcessingYour")}{" "}
            <strong>{processingDocs?.length}</strong> {_t("newDocuments")}
          </p>
        </div>
      </div>
    );
  };

  const ScannedTooltip = ({ index }) => {
    return (
      <ReactTooltip
        id={`scanned-doc-icon-${index}`}
        noArrow
        className="react-tooltip-styling details-skor-tooltip"
        render={() => (
          <p>{_t("thisSectionContainsScannedDocumentsThatCannotBeAnalyzed")}</p>
        )}
      />
    );
  };

  const MissingDocTooltip = ({ index }) => {
    return (
      <ReactTooltip
        id={`missing-doc-icon-${index}`}
        noArrow
        className="react-tooltip-styling details-skor-tooltip"
        render={() => <p>{_t("missingDocTooltipDescription")}</p>}
      />
    );
  };

  const WarningTooltip = ({ index }) => {
    return (
      <ReactTooltip
        id={`warning-doc-icon-${index}`}
        noArrow
        className="react-tooltip-styling details-skor-tooltip"
        render={() => <p>{_t("someDocumentsInThisSectionRequireReview")}</p>}
      />
    );
  };

  const HighRiskTooltip = ({ index }) => {
    return (
      <ReactTooltip
        id={`high-risk-doc-icon-${index}`}
        noArrow
        className="react-tooltip-styling details-skor-tooltip"
        render={() => (
          <p>{_t("someDocumentsInThisSectionShowSignsOfTampering")}</p>
        )}
      />
    );
  };

  const MissingDocView = ({ doc }) => (
    <div
      className={`d-flex align-items-center gap-4 justify-content-between BorderB2 py-2 missingDocWrapper${
        missingDocumentsResolved ? " missingDocWrapper--resolved" : ""
      }`}
    >
      <div className="missingDocWrapper__content d-flex align-items-center gap-2">
        <div className="docList docList2">
          <img
            src="/images/red-document-icon.svg"
            alt="Vector Icon"
            className="vactorImg2"
          />
        </div>
        <div className="texReport_div">
          <p>{_t(doc[0], "", "fixed")}</p>
        </div>
      </div>
      {missingDocumentsResolved && (
        <span className="missing-doc-resolved-badge">
          <span aria-hidden="true">✓</span> {_t("resolved", "Resolved")}
        </span>
      )}
    </div>
  );

  const ClaveButton = ({ className }) => (
    <div
      className={`clickBtn2 tooltipButton position-relative d-flex align-items-center gap-2 ${className}`}
    >
      <p>Cl@ve</p>
      <ul className="customTooltip">{_t("claveTooltip")}</ul>
    </div>
  );

  const DocumentView = ({ doc, index }) => (
    <div
      className={`d-flex align-items-center gap-4 justify-content-between BorderB2`}
      style={{
        background: index % 2 !== 0 && isFromReport ? "rgb(246, 246, 246)" : "",
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <div className="docList">
          <img src={DocIcon} alt="Vector Icon" className="vactorImg2" />
        </div>
        <div className="texReport_div">
          <p
            className="text-decoration-underline-hover cursor-pointer"
            onClick={() => {
              setDocHistoryPopup(false);
              setSelectedTypeForHistory(doc?.type ?? null);
              setDocHistoryPopup(true);
              setSelectedIndex(index);
            }}
          >
            {haveValue(doc?.bucketName)
              ? doc?.bucketName
              : _t(doc?.type, "", "fixed")}{" "}
            {doc?.type === "Working life certificate" &&
              haveValue(
                forensicAnalysis?.["Work Life Certificate"]?.dataInJSON
                  ?.reportDate
              ) &&
              `(${moment(
                forensicAnalysis?.["Work Life Certificate"]?.dataInJSON
                  ?.reportDate
              ).format("D MMMM YYYY")})`}
          </p>
          {doc && (
            <p className="updatedlist">
              {_t("uploadedOn")} {moment(doc?.created_at).format("DD-MM-YYYY")}
              {isOtherUserDoc(doc) && (
                <span className="uploaddoc">
                  <img src={DotIcon} alt="Vector Icon" className="" />
                  {_t("uploadedFor")} {getDocOwnerLabel(doc)}
                </span>
              )}
            </p>
          )}
          {doc?.from == "clave" && <ClaveButton className="hideOnDesktop" />}
        </div>
      </div>
      <div className="d-flex align-items-center gap-2">
        {doc?.from == "clave" && <ClaveButton className="hideOnMobile" />}
        <div className="d-flex">
          {doc?.verified && (
            <img src={CheckIcon0} alt="Vector Icon" className="vactorImg" />
          )}
        </div>
      </div>
    </div>
  );

  const DocumentFilters = () => {
    const allUploadedDocs = tenantDocsData ?? [];

    // 🔹 Count based on verdicts
    let trustedCount = 0;
    let normalCount = 0;
    let warningCount = 0;
    let highRiskCount = 0;
    let processingDocsCount = 0;
    let scannedCount = 0;

    for (const doc of allUploadedDocs) {
      const docTypeKey = doc?.type;
      const mappedDoc = documentsByType?.[docTypeKey];

      if (
        (!doc?.isDocumentAnalysisBucket &&
          (!mappedDoc || mappedDoc?.file_name !== doc?.file_name) &&
          !docTypeKey?.toLowerCase().includes("payslip")) ||
        docTypeKey === "uploaded-from-onboarding"
      )
        continue;

      const isDeclarationConsent = docTypeKey === "Declaration Consent";
      const verdict = isDeclarationConsent
        ? "NORMAL"
        : forensicDocumentReport?.[doc?.file_name]?.verdict;
      const scannedDoc = isDeclarationConsent
        ? false
        : forensicDocumentReport?.[doc?.file_name]?.documentType ===
            "is_scanned_document" ||
          forensicDocumentReport?.[doc?.file_name]?.isScannedDocument === "yes";
      if (scannedDoc) {
        scannedCount++;
        continue;
      }
      if (verdict === "HIGH_RISK") highRiskCount++;
      else if (verdict === "WARNING") warningCount++;
      else if (verdict === "TRUSTED") trustedCount++;
      else if (verdict === "NORMAL") normalCount++;
      else warningCount++;
    }

    for (const doc of processingDocs) {
      const docTypeKey = doc?.type;
      if (docTypeKey === "uploaded-from-onboarding") {
        processingDocsCount++;
      }
    }

    setAllRenderedDocumentsCount(
      trustedCount +
        normalCount +
        warningCount +
        highRiskCount +
        processingDocsCount +
        scannedCount
    );

    if (llShowOnly) {
      return (
        <div className="docs-padding">
          <div className="row g-3 docFilterButtonsContainer">
            <FilterTag
              isActive={selectedVerdicts.includes("TRUSTED")}
              name={_t("trusted")}
              src="/images/trusted.svg"
              onClick={() => toggleVerdictFilter("TRUSTED")}
              count={trustedCount}
            />

            <FilterTag
              isActive={selectedVerdicts.includes("NORMAL")}
              name={_t("normal")}
              src="/images/normal.svg"
              onClick={() => toggleVerdictFilter("NORMAL")}
              count={normalCount}
            />

            <FilterTag
              isActive={selectedVerdicts.includes("WARNING")}
              name={_t("warning")}
              src="/images/warning.svg"
              onClick={() => toggleVerdictFilter("WARNING")}
              count={warningCount}
            />

            <FilterTag
              isActive={selectedVerdicts.includes("HIGH_RISK")}
              name={_t("highRisk")}
              src="/images/high-risk.svg"
              onClick={() => toggleVerdictFilter("HIGH_RISK")}
              count={highRiskCount}
            />
          </div>
        </div>
      );
    } else {
      return;
    }
  };

  const DocumentViewWrapper = ({ isFromDesktop }) => {
    return (
      <>
        <div
          className={`main_doc_div mainDocDivHome px-0 ${
            isFromDesktop ? "hideOnMobile" : ""
          } ${isFromReport ? "main_doc_div_report_wrapper" : ""}`}
        >
          <div className={`w-100 ${isFromReport ? "docReportWrapper" : ""}`}>
            <div className=" docs-padding">
              <div className="d-flex position-relative align-items-center gap-4 justify-content-between BorderB">
                <div className="d-flex align-items-center gap-3 justify-content-center">
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <img
                      src={Document}
                      alt="Vector Icon"
                      className="vactorImg"
                    />
                    <p className="docheader">{_t("documents")}</p>
                    <p className="docnumber">
                      {isFromReport
                        ? Array.isArray(tenantDocsData)
                          ? tenantDocsData.length
                          : 0
                        : allRenderedDocumentsCount}
                    </p>
                    {(() => {
                      if (
                        !processingDocs?.length ||
                        selectedVerdicts.length > 0
                      )
                        return null;

                      return (
                        <div className="position-relative">
                          {llShowOnly && (
                            <div
                              onClick={() => handleDropdownToggle("processing")}
                              style={
                                showDropdown.processing
                                  ? {
                                      borderBottomLeftRadius: 0,
                                      borderBottomRightRadius: 0,
                                      color: "#e4eee8",
                                    }
                                  : { color: "#e4eee8" }
                              }
                              className="d-flex processing-docs-card justify-content-between cursor-pointer align-items-center"
                            >
                              <div className="d-flex justify-content-between align-items-center documents-container-info-card-img">
                                <LoadingSpinner
                                  size={"0.6944vw"}
                                  color="#253837"
                                  borderWidth={1}
                                  className={"docs-loading-spinner"}
                                />
                                <span>{_t("processingDocuments")}...</span>
                              </div>
                              <div className="d-flex align-items-center custom-gap-2">
                                <div className="doc-pl">
                                  <span>({processingDocs?.length})</span>
                                </div>
                                <div
                                  style={{ color: "#e4eee8" }}
                                  className="cursor-pointer"
                                >
                                  {showDropdown.processing ? (
                                    <IoIosArrowUp
                                      size={14}
                                      style={{ color: "#253837" }}
                                    />
                                  ) : (
                                    <IoIosArrowDown
                                      size={14}
                                      style={{ color: "#253837" }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          {showDropdown.processing && (
                            <div className="processing-doc-inner-container position-absolute">
                              {processingDocs.map((doc, index) => (
                                <div
                                  key={doc?._id || index}
                                  className="d-flex processing-doc-inner-container-padding justify-content-between position-relative align-items-center"
                                >
                                  <div className="d-flex justify-content-between align-items-center doc-name-wrapper">
                                    <div className="d-flex">
                                      <div className="d-flex align-items-center">
                                        <img
                                          className="processing-doc-icon"
                                          src={"/images/file-icon.svg"}
                                        />
                                        <div className="process-file-name">
                                          <p className="docName mb-0">
                                            {removeUuidFromFileName(
                                              doc?.file_name
                                            )}
                                          </p>
                                        </div>
                                        <div className="processing-doc-margin">
                                          <LoadingSpinner
                                            size={"0.5556vw"}
                                            color="#253837"
                                            borderWidth={1}
                                            className={
                                              "docs-loading-spinner-mobile"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    <p className="processing-classifying">
                                      {_t("classifying")}...
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                  {/* <div
                  className="d-flex align-items-center gap-2 cursor-pointer"
                  onClick={(e) => handleScrollPending()}
                >
                  <p className="docheader">{_t("pending")}</p>
                  <p className="docnumber docnumberPending">
                    {missingDocs?.length ?? 0}
                  </p>
                </div> */}
                </div>
                <div className="d-flex upload-docs-btn-mobile align-items-center custom-gap-2">
                  {processingDocs?.length === 0 &&
                    !llShowOnly &&
                    !isReadOnly && (
                      <div
                        style={{ display: "inline-block" }}
                        data-tooltip-id={
                          isProfileOutdated
                            ? "upload-docs-blocked-tooltip"
                            : undefined
                        }
                      >
                        <button
                          disabled={isProfileOutdated}
                          onClick={() => {
                            if (isProfileOutdated) return;
                            setUploadDocModel(true);
                          }}
                          style={
                            isProfileOutdated ? { opacity: 0.5 } : undefined
                          }
                          className="addGuarantorButton updateDocumentButton hideOnMobile align-items-center custom-gap-2"
                        >
                          <img src="/images/updateDocumentsIcon.svg" alt="" />
                          {_t("updateDocuments")}
                        </button>
                        <ReactTooltip
                          id="upload-docs-blocked-tooltip"
                          place="top"
                          className="react-tooltip-styling"
                          render={() =>
                            isProfileOutdated ? (
                              <p>
                                {_t(
                                  "profileOutdatedRenewFirst",
                                  "Your profile is outdated. Please renew your profile first."
                                )}
                              </p>
                            ) : null
                          }
                        />
                      </div>
                    )}

                  {llShowOnly && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {showSpinner ? (
                        <Spinner className="view_document_spinner" />
                      ) : (
                        <img
                          src={DownloadIcon}
                          alt="Vector Icon"
                          className="vactorImg2 downloadIcon cursor-pointer"
                          onClick={handleZipDown}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div>
              {!isFromReport ? (
                <div>
                  <DocumentFilters />

                  {processingDocs?.length > 0 && !llShowOnly ? (
                    <DocumentLoading />
                  ) : (
                    <div
                      ref={scrollContainerRef}
                      className="mainWrapperForensicDocs"
                    >
                      <div className="documents-container-info"></div>
                      {scannedDocsCount > 0 && llShowOnly ? (
                        <p
                          className={`documents-cannot-be-analyzed-text d-flex align-items-center custom-gap-2 ${
                            selectedVerdicts.includes("SCANNED")
                              ? "documents-cannot-be-analyzed-text-active"
                              : ""
                          }`}
                          onClick={() => toggleVerdictFilter("SCANNED")}
                        >
                          <img
                            src="/images/search-with-cross-icon.svg"
                            alt=""
                          />
                          {scannedDocsCount}{" "}
                          {_t("documentsCannotBeAnalyzedScannedForImages")}
                        </p>
                      ) : null}

                      {/* Processing Documents */}

                      {/* For Identification documents */}
                      <IdentificationSection
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        forensicAnalysis={forensicAnalysis}
                        forensicDocsMap={forensicDocsMap}
                        employmentType={employmentType}
                        getDocsForType={getDocsForType}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                        showOnfidoCustomTooltipMessages={
                          showOnfidoCustomTooltipMessages
                        }
                      />

                      {/* For Employment status documents */}
                      <EmploymentStatusSection
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        forensicAnalysis={forensicAnalysis}
                        forensicDocsMap={forensicDocsMap}
                        employmentType={employmentType}
                        getDocsForType={getDocsForType}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                      />

                      {/* For Income taxes documents */}
                      <IncomeTaxesSection
                        allForensicDocuments={allForensicDocuments}
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        forensicAnalysis={forensicAnalysis}
                        forensicDocsMap={forensicDocsMap}
                        employmentType={employmentType}
                        getDocsForType={getDocsForType}
                        getPayslipDocs={getPayslipDocs}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                        user={user}
                      />

                      {/* Other documents */}
                      <OtherDocsSection
                        otherDocs={getOtherDocs()}
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        documentsByType={documentsByType}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        forensicAnalysis={forensicAnalysis}
                      />

                      {/* Protected housing documents */}
                      <ProtectedHousingSection
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        getRequiredProtectedHousingDocs={
                          getRequiredProtectedHousingDocs
                        }
                        getDocsForType={getDocsForType}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                      />

                      <NoDocumentsFound
                        forensicDocsMap={forensicDocsMap}
                        employmentType={employmentType}
                        getDocsForType={getDocsForType}
                        getPayslipDocs={getPayslipDocs}
                        getRequiredProtectedHousingDocs={
                          getRequiredProtectedHousingDocs
                        }
                        getOtherDocs={getOtherDocs}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                      />
                    </div>
                  )}
                </div>
              ) : (
                docsToRender?.map((doc, index) =>
                  isFromReport && doc?.type === "missing" ? (
                    <MissingDocView doc={doc} key={index} />
                  ) : (
                    <DocumentView doc={doc} index={index} key={index} />
                  )
                )
              )}
            </div>
          </div>
          {isFromReport && (
            <div
              className={`${
                missingDocs.length > 0
                  ? "bgclolr_change custom-mt-3"
                  : "missing_doc bgclolr_change custom-mt-3"
              }`}
              id="missingDocs"
            >
              {isFromReport &&
                reportDocsSecondHalf?.map((doc, index) =>
                  doc.type === "missing" ? (
                    <>
                      <MissingDocView doc={doc} key={index} />
                    </>
                  ) : (
                    <>
                      <DocumentView doc={doc} index={index} key={index} />
                    </>
                  )
                )}
              {!isFromReport && missingDocs?.length > 0 && (
                <div className="d-flex align-items-center gap-2 BorderB2">
                  <img
                    src={noticIcon}
                    alt="Vector Icon"
                    className="vactorImg2"
                  />
                  <p className="docheader">{_t("missingDocuments")}</p>
                </div>
              )}
              {!isFromReport && (
                <div
                  className={`documents_fixed
                              ${
                                isFromReport
                                  ? "fullHeightReport"
                                  : missingDocs?.length > 12 &&
                                      tenantDocsData?.length === 0
                                    ? "greeterThenTenHeight"
                                    : missingDocs?.length > 5 &&
                                        tenantDocsData?.length === 0
                                      ? "greeterThenFiveHeight"
                                      : missingDocs?.length > 5 &&
                                          tenantDocsData?.length > 5
                                        ? "bothGreaterThenFive"
                                        : "lessThenFiveHeight"
                              }`}
                >
                  {Object.entries(mandatoryDocsList)?.map(([key, value]) => {
                    const isPayslipKey = key.toLowerCase().includes("payslip");

                    if (hasModel100Fallback(key)) return null;

                    // Slot-aware for 3-payslip employment types, else doc count.
                    const useSlots =
                      isThreePayslipRequiredHere &&
                      Object.keys(mandatoryDocsList).some((k) =>
                        k.toLowerCase().includes("payslip")
                      );
                    const payslipSatisfiedCount = useSlots
                      ? payslipSlotInfo.filled
                      : getPayslipUploadedCount(tenantDocsHistory);

                    if (isPayslipKey) {
                      const index = PAYSLIP_ORDER.indexOf(key);

                      if (index !== -1) {
                        if (index < payslipSatisfiedCount) {
                          return null;
                        }
                      } else {
                        if (useSlots) {
                          // Generic key expanded: satisfied only when all 3
                          // slots are filled.
                          if (payslipSatisfiedCount >= 3) {
                            return null;
                          }
                        } else {
                          const needed =
                            key.toLowerCase() === "last 3 payslips" ? 3 : 1;
                          if (payslipSatisfiedCount >= needed) {
                            return null;
                          }
                        }
                      }
                    }

                    // normal missing document check
                    if (!(key in tenantDocsHistory && !isPayslipKey)) {
                      return (
                        <div
                          key={key}
                          className="d-flex align-items-center gap-4 justify-content-between BorderB2 py-2 missingDocWrapper"
                        >
                          <div className="d-flex align-items-center gap-2">
                            <div className="docList docList2">
                              <img
                                src="/images/red-document-icon.svg"
                                alt="Vector Icon"
                                className="vactorImg2"
                              />
                            </div>
                            <div className="texReport_div">
                              <p>{_t(key, "", "fixed")}</p>
                            </div>
                          </div>
                        </div>
                      );
                    }

                    return null;
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <div
        className={`${
          isFromReport ? "col-md-12" : "col-md-6"
        } custom-items--stretch`}
      >
        <DocumentViewWrapper isFromDesktop={true} />
        {docModel && (
          <div
            className="popup-overlay fixed inset-0 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen guarantorBg documentViewModal"
            onClick={() => setDocModel(false)}
          >
            <div
              className="contentMainWrapper"
              onClick={(e) => e.stopPropagation()}
            >
              <span className="drawerIcon" onClick={() => setDocModel(false)} />
              <div className="col-md-6 custom-items--stretch">
                <DocumentViewWrapper />
              </div>
              {!llShowOnly && (
                <button
                  onClick={() => setUploadDocModel(true)}
                  className="addGuarantorButton updateDocumentButton align-items-center custom-gap-2"
                >
                  <img src="/images/updateDocumentsIcon.svg" alt="" />
                  {_t("updateDocuments")}
                </button>
              )}
            </div>
          </div>
        )}
        <DocHistoryPopup
          isOpen={docHistoryPopup}
          user={user}
          onClose={() => {
            setDocHistoryPopup(false);
            setSelectedIndex(0);
          }}
          docName={selectedTypeForHistory}
          allData={tenantDocsData}
          previousUploads={getPreviousUploadsForPopup()}
          handlePreviewDocument={handlePreviewDocument}
          selectedIndex={selectedIndex}
          allForensicDocuments={allForensicDocuments}
          currentLang={currentLang}
        />
        {!llShowOnly && (
          <DocUploadingComponentWithAnalysing
            isOpen={uploadDocModel}
            onClose={() => setUploadDocModel(false)}
            user={user}
            fetchFileDataParent={fetchFileData}
            isGuarantor={isGuarantor}
          />
        )}
      </div>
      <div
        className={`myDocumentsButton ${isSkorSdkSearch() ? "isSkorSdkDocumentMode" : ""} ${scrolled ? "expanded" : ""}`}
        onClick={() => setDocModel(true)}
      >
        <div className="docIconWrapper d-flex align-items-center justify-content-center">
          <img src="/images/docIconGreen.svg" alt="doc" />
        </div>
        <p>{_t("myDocuments")}</p>
        <img
          src="/images/arrow-right-white.svg"
          className="arrow-right-button"
          alt="arrow"
        />
      </div>
      <DeleteConfirationForDoc
        isOpen={deleteDocumentConfirmation}
        onClose={() => setDeleteDocumentConfirmation(false)}
        name={_t(selectedDocument?.type, "", "fixed") ?? ""}
        heading={_t("deleteDocument")}
        description={_t("areYouSureDoYouWantToDeleteThisDocument")}
        btn1Text={_t("noGoBack")}
        btn2Text={_t("yesDelete")}
        btn1Functionality={() => setDeleteDocumentConfirmation(false)}
        btn2Functionality={() => handleDeleteDocument(selectedDocument?._id)}
        submitLoading={deleteDocumentLoading}
      />
    </>
  );
};
export default DetailsDocs;
